module.exports = __webpack_public_path__ + "img/glass-wine.4102d9fd.svg";